import { numberFormatter } from "../../gridFormatters";
import { wtAvg } from "../../math";

export const hostPerformanceDetail = [
	{
		"field": "host_name",
		"headerName": "Host"
	},
	{
		"field": "lun_name",
		"headerName": "LUN Name"
	},
	{
		"field": "device_name",
		"headerName": "Array Name"
	},
	{
		"field": "write_io",
		"headerName": "Write IO",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "read_io",
		"headerName": "Read IO",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
	},
	{
		"field": "latency",
		"headerName": "Avg Read Latency",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
		"aggFunc": p => wtAvg(p, "latency", "read_io")
	},
	{
		"field": "write_latency",
		"headerName": "Avg Write Latency",
		"hide": "true",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
		"aggFunc": p => wtAvg(p, "latency", "write_io")
	},
	{
		"field": "lun_size",
		"headerName": "LUN Size",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "lun_used",
		"headerName": "LUN Used",
		"hide": "true",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "read_mb_sec",
		"headerName": "Read MB/Sec",
		"hide": "true",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum"
	},
	{
		"field": "write_mb_sec",
		"headerName": "Write MB/Sec",
		"hide": "true",
        "type": "numericColumn",
		"filter": "agNumberColumnFilter",
		"cellRenderer": numberFormatter,
		"aggFunc": "sum"
	}
];